import { render, staticRenderFns } from "./settingDefault.vue?vue&type=template&id=ec139a02"
import script from "./settingDefault.vue?vue&type=script&lang=js"
export * from "./settingDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports